import styled from 'styled-components'

export const InventoryEmpty = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    gap: 20px;
`

export const InventoryEmptyMessage = styled.div`
    background-color: #ebebeb;
    padding: 40px 25px;
    border-radius: 10px;
    box-shadow: inset 0px 0px 50px 10px rgb(0 0 0 / 15%);
    font-weight: 500;
    font-style: normal;
    font-size: 16px;
    line-height: 1;
    text-align: center;
`
